import { useQuery } from '@tanstack/react-query';
import { strategyApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { StrategyFilters } from '../types/strategy';

/**
 * Hook for fetching strategies list
 */
export function useStrategies(filters: Partial<StrategyFilters>) {
  return useQuery({
    queryKey: queryKeys.strategies.list(filters),
    queryFn: () => strategyApi.listStrategies(filters),
    placeholderData: (previousData) => previousData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}

/**
 * Hook for fetching strategy categories
 */
export function useStrategyCategories() {
  return useQuery({
    queryKey: queryKeys.strategyCategories.list(),
    queryFn: async () => {
      const response = await strategyApi.getCategories();
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
  });
}

/**
 * Hook for fetching predefined images
 */
export function usePredefinedImages() {
  return useQuery({
    queryKey: queryKeys.predefinedImages.list(),
    queryFn: async () => {
      const response = await strategyApi.getPredefinedImages();
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
  });
}

/**
 * Hook for fetching predefined strategy icons
 */
export function useStrategyIcons() {
  return useQuery({
    queryKey: queryKeys.strategyIcons.list(),
    queryFn: async () => {
      const response = await strategyApi.getStrategyIcons();
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
  });
}
